import React from 'react';

import { useGlobal } from '../../contexts/Global/context';

import * as S from './styles';

function Tag({ children, tagColor }) {
    const { contrastTheme } = useGlobal();

    return (
        <S.StyledTag contrastTheme={contrastTheme} tagColor={tagColor}>
            {children}
        </S.StyledTag>
    );
}

export default Tag;
